import { Basket } from 'types/common';
import { AnnouncementGroupMember } from 'types/user';

export const ANNOUNCEMENTS = 'announcements';
export const ANNOUNCEMENT_GROUPS = 'announcementGroups';

export type AnnouncementsTabs = typeof ANNOUNCEMENTS | typeof ANNOUNCEMENT_GROUPS;

export interface Announcements {
    currentTab: AnnouncementsTabs;
}

export interface AnnouncementData {
    imgUrl: string | null;
    eventId: number;
    firstName: string;
    lastName: string;
    type: string;
    username: string;
    announcementGroupId: string;
}

export interface Announcement {
    id: number;
    title: string;
    message: string;
    data: AnnouncementData;
    createDate: string;
    read: boolean;
}

export interface NewAnnouncement {
    title: string;
    message: string;
    companyId?: number | null;
    data: {
        announcementGroupId: number | null;
        notificationType: string;
        firstName?: string;
        lastName?: string;
        event?: Pick<Basket, 'id' | 'name'>;
    };
}
export interface AnnouncementGroup {
    title: string;
    imageUrl: string;
    id: number;
    contact: string;
    totalParticipants: string;
}
export interface AnnouncementGroupDetailState {
    members: Array<AnnouncementGroupMember>;
    details: AnnouncementGroup | null;
    membersLoading: boolean;
    detailsLoading: boolean;
    error: string | null;
    groupName: string | null;
    groupImage: string | null;
}
export interface RemoveGroupMember {
    userName: string;
    announcementGroupId: number;
}
export interface AnnouncementState {
    data: Announcement[];
    loading: boolean;
    error: boolean;
    totalCount: number;
}

export interface SendAnnouncementState {
    loading: boolean;
    error: boolean | string;
}

export interface SendAnnouncementProps {
    defaultValues: NewAnnouncement;
}

export interface AnnouncementDetailState {
    details: Announcement | null;
    loading: boolean;
    error: boolean;
}

export type NotificationStatus = 'READ' | 'UNREAD' | 'ALL';

export interface DeleteAnnouncementPayload {
    id: number;
    pageNumber: number;
}
